import axios from "./axios";

export interface Deal {
  id: number;
  title: string;
  clientId: number;
  pipelineId: number;
  stageId: number;
  responsibleUserId: number | null;
  amount: number;
  order: number;
  createdAt: string;
  updatedAt: string;
  status: "active" | "won" | "lost";
  number: string;
  description?: string;
  paymentMethod?: string | null;
  prepayment?: number | null;
  dealDate?: string | null;
  activationKeys?: string[] | null;
  downloadLinks?: string[] | null;
  paidAt?: string | null;
  keysOpenedAt?: string | null;
  receiptUrl?: string | null;
  coExecutorIds?: number[] | null;
  deleteRequestedById?: number | null;
  deleteRequestedAt?: string | null;
  deleteRequestReason?: string | null;
}

export interface CreateDealDto {
  title: string;
  clientId: number;
  pipelineId: number;
  stageId: number;
}

export interface UpdateDealDto {
  title?: string;
  clientId?: number;
  responsibleUserId?: number;
}

export interface UpdateOrderDto {
  stageId: number;
  order: number;
}

export const DealsAPI = {
  // ---------------------------
  // CRUD по сделкам
  // ---------------------------
  create: (dto: CreateDealDto) =>
    axios.post("/deals", dto),

  getById: (id: number) =>
    axios.get(`/deals/${id}`),

  update: (id: number, dto: any) =>
    axios.put(`/deals/${id}`, dto),

  updateStage: (id: number, dto: { pipelineId: number; stageId: number }) =>
    axios.put(`/deals/${id}/stage`, { stageId: dto.stageId }),

  updateOrder: (id: number, dto: UpdateOrderDto) =>
    axios.put(`/deals/${id}/order`, dto),

  // Соисполнители и запросы на удаление
  setCoExecutors: (id: number, userIds: number[]) =>
    axios.put(`/deals/${id}/co-executors`, { userIds }),

  requestDelete: (id: number, reason?: string) =>
    axios.post(`/deals/${id}/delete-request`, { reason }),

  approveDelete: (id: number) =>
    axios.post(`/deals/${id}/delete-request/approve`),

  rejectDelete: (id: number) =>
    axios.post(`/deals/${id}/delete-request/reject`),

  deleteRequests: () =>
    axios.get(`/deals/delete-requests`).then((r) => r.data as any[]),

  delete: (id: number) =>
    axios.delete(`/deals/${id}`),

  win: (id: number) =>
    axios.put(`/deals/${id}/win`),

  winNoFiscal: (id: number) =>
    axios.put(`/deals/${id}/win-no-fiscal`),

  lose: (id: number) =>
    axios.put(`/deals/${id}/lose`),

   getFinished: () => axios.get("/deals/finished"),
  // ---------------------------
  // Фильтры
  // ---------------------------
  getByPipeline: (pipelineId: number) =>
    axios.get(`/pipelines/${pipelineId}/deals`),

  getByStage: (stageId: number) =>
    axios.get(`/stages/${stageId}/deals`),

  getByClient: (clientId: number) =>
    axios.get(`/clients/${clientId}/deals`),

  getTimeline: (id: number) =>
    axios.get(`/deals/${id}/timeline`),

  // ---------------------------
  // ТОВАРЫ В СДЕЛКЕ
  // ---------------------------
  addProduct: (
    dealId: number,
    dto: { productId: number; quantity: number; price: number }
  ) => axios.post(`/deals/${dealId}/products`, dto),

  updateProduct: (
    dealProductId: number,
    dto: { quantity: number; price: number }
  ) => axios.put(`/deals/products/${dealProductId}`, dto),

  removeProduct: (dealProductId: number) =>
    axios.delete(`/deals/products/${dealProductId}`),

  updateResponsible: (id: number, dto: { userId: number }) =>
    axios.put(`/deals/${id}/responsible`, dto),

  updateKeys: (id: number, keys: string[]) =>
    axios.patch(`/deals/${id}/keys`, { keys }),

  requestMontKeys: (id: number) =>
    axios.post(`/deals/${id}/request-mont-keys`),
};

// --- Compatibility exports for existing frontend ---
export const createDeal = DealsAPI.create;
export const updateDeal = DealsAPI.update;
export const deleteDeal = DealsAPI.delete;
export const getDealsByPipeline = DealsAPI.getByPipeline;

export type DealDto = Deal;
